import { useTranslation } from "react-i18next";
import React from "react";
import { StepsItemProps } from "../StepsItem/StepsItem.types";
import "./style.scss";

interface StepsContentGridProps {
  processing: boolean;
  config: any[];
  itemComponent: React.FC<StepsItemProps>,
  data: any;
}

export const StepsContentGrid: React.FC<StepsContentGridProps> = ({
  processing,
  config,
  itemComponent: ItemComponent,
  data,
}: StepsContentGridProps) => {
  const { t } = useTranslation();

  return (
    <div className="table-steps">
      { data && data.length > 0 &&
      <div className="table-steps__header">
        {config.map((item: string, index: number) => (
          <div
            key={index}
            className={`table-steps__head ${item
              .replace(" ", "-")
              .toLowerCase()}`}
          >
            {t(item.replace(" ", "_").toLowerCase() + "_string")}
          </div>
        ))}
      </div> }
      <div className="table-steps__table">
        {data &&
          data.map((item: any, index: number) => {
            let classes = [];
            const isApproval = item.approval_date && item.approval_date !== '-';
            if(isApproval || item.passed) classes.push('completed');
            return (
              <ItemComponent key={item.id+"_"+index} data={item} processing={processing} customClasses={classes.join(' ')} config={config} />
            )
          })}
      </div>
    </div>
  );
};

export * from "./functions";